import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Get softpull submit
 * @param {object} payload - form values
 * @param {{ signal?: AbortSignal }} [options] - abort signal
 */
export async function getSoftpullResponse(payload, { signal } = {}) {
  const BASE_URL = getMiddlewareUrl()

  try {
    const response = await fetch(`${BASE_URL}/api/salesforce/second-step`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal,
    })

    if (!response.ok) {
      throw new Error(`Fetch ${BASE_URL}/api/salesforce/second-step failed!`)
    }

    const data = await response.json()
    // return data obj if success is true, if success is false they are sent to 1st chat link
    if (data.success === true) {
      return data
    }
  } catch (error) {
    console.error(error)
  }
}
